module.exports = __webpack_public_path__ + "static/img/6273_phase_function_Paper_Points.afe67d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6273_phase_function_Paper_Points.png
// module id = GhgI
// module chunks = 0